import React, {Component} from 'react';
import {Alert} from 'antd';

class Notfound extends Component {
  render() {
    return (
      <div
        style={{
          width: 500,
          height: 500,
          margin: '0 auto',
          marginTop: '10%'
        }}
      >
        <Alert
          message="404"
          description="页面丢失，请检查您的地址"
          type="warning"
          showIcon
        />
      </div>
    );
  }
}

export default Notfound;



// WEBPACK FOOTER //
// ./src/containers/404.js